import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => {
        return {
            enums: state.dictionaries.enums,
            roles: state.profile.roles,
            organizationTimezone: state.profile.timezone,
            organization: state.profile.organization,
            profile: state.profile.profile,
        };
    };
    const mapDispatch = () => ({});
    return connect(mapState, mapDispatch)(Component);
}
